import { Injectable } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { TreeNode } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class TreeService {

  createTree(cat: any[]): TreeNode[] {
      // Build the tree structure
      const treeNodes: TreeNode[] = [];
      const categoriesMap: Map<number, TreeNode> = new Map();
    
      // Helper function to recursively add children to a node
      const addChildNodes = (parentNode: TreeNode, items: any[]) => {
        items.forEach(item => {
          if (item.parentNodeId === parentNode.nodeId) {
            const node: TreeNode = {
              nodeId: item.nodeId, // Assign nodeId
              
            parentNode: item.parentNodeId,
              name: item.description,
              type: item.type,
              children: []
            };
            parentNode.children.push(node);
            addChildNodes(node, items); // Recursively add children
          }
        });
      };
    
      // First pass: Create category nodes
      cat.forEach(item => {
        if (item.type === 'category') {
          const node: TreeNode = {
            nodeId: item.nodeId, // Assign nodeId
            parentNode: item.parentNodeId,
            name: item.description,
            type: item.type,
            children: []
          };
          treeNodes.push(node);
          categoriesMap.set(item.nodeId, node);
        }
      });
    
      // Second pass: Create subcategory and topic nodes
      cat.forEach(item => {
        if ((item.type === 'subcategory' || item.type === 'topic') && categoriesMap.has(item.parentNodeId)) {
          const parentNode = categoriesMap.get(item.parentNodeId);
          if (parentNode) {
            const node: TreeNode = {
              nodeId: item.nodeId, // Assign nodeId
              
            parentNode: item.parentNodeId,
              name: item.description,
              type: item.type,
              children: []
            };
            parentNode.children.push(node);
            addChildNodes(node, cat); // Recursively add children
          }
        }
      });
      
    return treeNodes;
  }

  expandTree(dataSource: MatTreeNestedDataSource<TreeNode>, treeControl: NestedTreeControl<TreeNode>) {
    const expandRecursive = (node: TreeNode) => {
      treeControl.expand(node);
      node.children.forEach(child => {
        expandRecursive(child);
      });
    };

    dataSource.data.forEach(node => {
      expandRecursive(node);
    });
  }

  findNodeById(tree: TreeNode[], id: number): TreeNode {
    // Perform a depth-first search to find the node with the specified ID
    const stack: TreeNode[] = [...tree];
    while (stack.length > 0) {
      const currentNode = stack.pop();
      if (currentNode.nodeId === id) {
        return currentNode;
      }
      if (currentNode.children) {
        stack.push(...currentNode.children);
      }
    }
    return null; // Node with the specified ID not found
  }

  editNodeName(node: TreeNode, newName: string): void {
    // Update the name of the specified node
    node.name = newName;
  }
  
  editNodeType(node: TreeNode, newType: string): void {
    // Update the type of the specified node
    node.type = newType;
  }

  deleteNode(tree: TreeNode[], nodeToDelete: TreeNode): void {
    // Perform a depth-first search to find and delete the specified node
    let index = -1;
    for (let i = 0; i < tree.length; i++) {
      if (tree[i] === nodeToDelete) {
        index = i;
        break;
      }
      if (tree[i].children) {
        this.deleteNode(tree[i].children, nodeToDelete);
      }
    }
    if (index !== -1) {
      tree.splice(index, 1);
    }
  }

}